import React from 'react';
import BlogCard from './BlogCard';

function BlogCardContainer() {
  // You can map over static data array
  const blogData = [
    {
      id: 1,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "May 20, 2025",
      title: "7 Easy Recipes Using Freeze-Dried Fruits (Smoothies, Bakes, Bowls)",
      description: "Make smoothies, bakes, and bowls healthier and tastier with Bonvie’s freeze-dried fruits. Try 7 easy...",
      link: "#"
    },
    {
      id: 2,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "May 22, 2025",
      title: "Best High-Protein Snacks for Gym & Travel",
      description: "Discover protein-packed snack options for energy on the go and after workouts.",
      link: "#"
    },
    {
      id: 3,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "May 25, 2025",
      title: "How to Add More Plant Protein to Your Diet",
      description: "Boost your meals with easy plant-based protein ideas and recipes.",
      link: "#"
    },
    {
      id: 4,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "May 28, 2025",
      title: "Quick Healthy Breakfast Ideas for Busy Mornings",
      description: "Start your day strong with these nutritious, quick breakfast ideas.",
      link: "#"
    },
    {
      id: 5,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "June 1, 2025",
      title: "Top Hydrating Foods for Summer",
      description: "Keep your body hydrated and refreshed with these top summer food picks.",
      link: "#"
    },
    {
      id: 6,
      image: "https://bonviesnacks.com/cdn/shop/articles/Frame_82.png?v=1747917404&width=1100",
      date: "June 5, 2025",
      title: "Snack Smarter: Healthy Alternatives You’ll Love",
      description: "Swap your old snacks with these healthy and delicious options.",
      link: "#"
    },
  ];

  return (
      <div className="container mx-auto px-4 py-8">
      {/* Grid config */}
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {blogData.map((blog) => (
          <BlogCard
            key={blog.id}
            image={blog.image}
            date={blog.date}
            title={blog.title}
            description={blog.description}
            link={blog.link}
          />
        ))}
      </div>
    </div>
  );
}

export default BlogCardContainer;
